export default __webpack_public_path__ + "static/media/pause.2dd6b8ba.svg";